import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Interval to show/hide popup
    const interval = setInterval(() => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    }, 20000); // Show every 20 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-271">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white p-4 rounded-xl shadow-warm-lg border border-cream-dark max-w-[320px] flex gap-3 items-start" data-id="element-272">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-carbon-lighter hover:text-carbon" data-id="element-273">
            <X className="w-4 h-4" data-id="element-274" />
          </button>

          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-275">
            <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-276" />
          </div>

          <div data-id="element-277">
            <p className="text-xs text-brand-green font-bold mb-1" data-id="element-278">
              Compra verificada
            </p>
            <p className="text-sm text-carbon leading-tight" data-id="element-279">
              <span className="font-bold" data-id="element-280">Florencia B.</span> de La Plata compró{' '}
              <span className="font-medium italic" data-id="element-281">
                Megapack + Marca Gourmet 🏆
              </span>{' '}
              hace 9 minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}